import React from 'react'
import PropTypes from 'prop-types'
import {
    ALL_SERVICES, NETWORK_OPTUS, NETWORK_TELSTRA,
    SERVICE_ADSL,
    SERVICE_FIBRE,
    SERVICE_MOBILE,
    SERVICE_MOBILE_BROADBAND,
    SERVICE_NBN,
    SERVICE_VOIP,
    SERVICE_WIRELESS
} from '../../constants'
import { Plan as MobilePlan } from './MobileElements'
import {
    Titles as DesktopTitles,
    Data as DesktopData,
    DataAdditional as DesktopDataAdditional,
    Speeds as DesktopSpeeds,
    Prices as DesktopPrices,
    Features as DesktopFeatures,
    PricePerGb as DesktopPricePerGb,
    Buttons as DesktopButtons,
    Terms as DesktopTerms,
    Html as DesktopHtml,
    AdditionalText1 as DesktopAdditionalText1,
    AdditionalText2 as DesktopAdditionalText2,
    PriceNotes
} from './DesktopElements'

const components = {
    titles: DesktopTitles,
    data: DesktopData,
    dataAdditional: DesktopDataAdditional,
    speeds: DesktopSpeeds,
    prices: DesktopPrices,
    pricePerGb: DesktopPricePerGb,
    features: DesktopFeatures,
    html: DesktopHtml,
    additionalText1: DesktopAdditionalText1,
    additionalText2: DesktopAdditionalText2,
    priceNotes: PriceNotes
}

const ComparePlans = (props) => {
    const mapPlansToData = () => {
        if ([SERVICE_NBN, SERVICE_FIBRE].includes(props.type)) {
            if (props.isFlipReady) {
                return ['data', 'speeds', 'prices','priceNotes', 'features', 'additionalText1']
            }

            return ['data', 'speeds', 'prices','priceNotes', 'features']
        }

        if (props.type === SERVICE_WIRELESS) {
            return ['data', 'prices', 'features']
        }

        if (props.type === SERVICE_MOBILE) {
            if (props.mobileNetwork === NETWORK_TELSTRA) {
                return ['prices', 'data', 'features', 'additionalText1', 'priceNotes', 'additionalText2']
            }

            return ['data', 'prices', 'features']
        }

        if (props.type === SERVICE_MOBILE_BROADBAND) {
            return ['data', 'prices', 'pricePerGb', 'features']
        }

        if (props.type === SERVICE_ADSL) {
            return ['data', 'speeds', 'prices', 'features']
        }

        if (props.type === SERVICE_VOIP) {
            return ['prices', 'html', 'features']
        }
    }

    const planSelected = plan => {
        if (plan.id === props.selectedPlanId) {
            return 'active'
        }

        return ''
    }

    return (
        <div className='row compare-plans mb-1'>
            <div className='col-12 d-none d-lg-block'>
                <table cellPadding='0' cellSpacing='0'>
                    <thead>
                        <DesktopTitles existingPlan={props.existingPlan} plans={props.plans} planSelected={planSelected} />
                    </thead>
                    <tbody>
                        {mapPlansToData().map((item, key) => {
                            const SpecificComponent = components[item]
                            return (
                                <SpecificComponent
                                    key={key}
                                    type={props.type}
                                    existingPlan={props.existingPlan}
                                    plans={props.plans}
                                    planSelected={planSelected}
                                />
                            )
                        })}
                        <DesktopButtons plans={props.plans} planSelected={planSelected} handleSelect={props.handleSelect} />
                        <DesktopTerms plans={props.plans} type={props.type} mobileNetwork={props.mobileNetwork} f2fPromo={props.f2fPromo} />
                    </tbody>
                </table>
            </div>

            <div className='col-12 d-lg-none'>
                <p className='m-0 mb-2 font-small text-center hide-when-not-reqd'>Current plan:</p>
                <div className='mb-5 hide-when-not-reqd'>
                    <MobilePlan
                        plan={props.existingPlan}
                        planSelected={planSelected}
                        handleSelect={props.handleSelect}
                        isExisting
                    />
                </div>
                <p className='m-0 mb-2 font-small text-center'>New plans:</p>
                {props.plans.map((item, key) => {
                    return (
                        <MobilePlan
                            key={key}
                            plan={item}
                            planSelected={planSelected}
                            handleSelect={props.handleSelect}
                        />
                    )
                })}
            </div>
        </div>
    )
}

ComparePlans.propTypes = {
    type: PropTypes.oneOf(ALL_SERVICES).isRequired,
    mobileNetwork: PropTypes.oneOf([NETWORK_TELSTRA, NETWORK_OPTUS]),
    handleSelect: PropTypes.func.isRequired,
    selectedPlanId: PropTypes.number,
    existingPlan: PropTypes.shape({
        title: PropTypes.string,
        data: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        dataAdditional: PropTypes.string,
        speed: PropTypes.string,
        price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        features: PropTypes.array
    }).isRequired,
    plans: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string,
        data: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        dataAdditional: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        speed: PropTypes.string,
        eveningSpeed: PropTypes.string,
        price: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
        features: PropTypes.array,
        additionalText1: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        additionalText2: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    })).isRequired,
    isFlipReady: PropTypes.bool
}

ComparePlans.defaultProps = {
    selectedPlanId: 0,
    existingPlan: {},
    plans: []
}

export default ComparePlans



// WEBPACK FOOTER //
// ./resources/js/components/ComparePlans/ComparePlans.js